import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import arrowup from "../../assets/arrowup.svg";
import close from "../../assets/close.svg";
import "./UnlikeModal.css";
function UnlikeModal({ handleHideModal, givenAnswer, givenQuestion }) {
  const [updatedAnswer, setupdatedAnswer] = useState(givenAnswer || "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Please wait...",
      background: "black",
      html: 'This may take a few moments.<br/><br/><div class="spinner-border" role="status"></div>',
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    console.log(updatedAnswer);
    try {
      const data = {
        question: givenQuestion,
        defaultAnswer: givenAnswer,
        correctAnswer: updatedAnswer,
      };
      await axios.post(
        "https://fitai-chat.fly.dev/train/addCorrectAnswer",
        data
      );
      Swal.fire({
        title: "Success!",
        background: "black",
        text: "Your request has been processed successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => handleHideModal());
    } catch (error) {
      console.log("error in adding resp", error);
      Swal.fire({
        icon: "error",
        background: "black",
        title: "Oops...",
        text: "Something went wrong!",
        confirmButtonText: "OK",
      }).then(() => handleHideModal());
    } finally {
    }
  };

  function handleChange(e) {
    setupdatedAnswer(e.target.value);
    console.log(updatedAnswer);
  }
  return (
    <div className=" p-5 bg-transparent backdrop-blur-md w-[700px] justify-center relative border border-white rounded-lg">
      <img
        alt="close"
        onClick={handleHideModal}
        className="w-6 close"
        src={close}
      ></img>
      <h1 className="mb-3 text-center">
        Please provide the appropriate response for &apos;{givenQuestion}&apos;
      </h1>
      <p className="text-gray-400 mb-3">(Please edit the default answer.)</p>
      <textarea
        autoComplete="off"
        rows="8"
        value={updatedAnswer}
        className="border border-white rounded-md p-2 w-full mx-auto bg-transparent "
        onChange={handleChange}
        placeholder="Type your answer here..."
      ></textarea>
      <button
        onClick={handleSubmit}
        className="mt-5 p-1 bg-[#0eb43b] rounded-md w-full"
      >
        Submit My Response
      </button>
    </div>
  );
}
export default UnlikeModal;
